import React from 'react';
import styled, { css } from 'styled-components';
import JustificationContainer from '~/components/atom/JustificationContainer';
import { Body } from '~/components/atom/Typography';
import type { ThemeColor } from '~/theme/System/tokens/colorPalette';

export type Props = {
  dataTestId?: string;
  className?: string;
  textColor: ThemeColor;
  backgroundColor: ThemeColor;
  label: string;
};

const Status: React.FCC<Props> = ({
  dataTestId,
  className,
  textColor,
  backgroundColor,
  label,
}) => (
  <Container
    data-testid={dataTestId}
    className={className}
    $color={textColor}
    width="max-content"
    border={{ radius: 's' }}
    backgroundColor={backgroundColor}
    align="center"
  >
    <Body
      margin={[null]}
      size="s"
      color={textColor}
      padding={[null, null, null, 'xs']}
    >
      {label}
    </Body>
  </Container>
);

const Container = styled(JustificationContainer)<{ $color: ThemeColor }>(
  ({ theme, $color }) => css`
    position: relative;
    padding: 4px;

    &:before {
      content: '';
      height: 70%;
      width: 3px;
      background-color: ${theme.color($color.group, $color.variant)};
      position: absolute;
      margin-right: ${theme.space('s')};
      border-radius: 2px;
    }
  `,
);

export default Status;
